import React from 'react';
import './VR.css';

const VR = () => {
  return (
    <div className="vr-tour-wrapper">
      <h3 className="vr-tour-heading">Virtual Reality Experience :</h3>
      <div className="vr-iframe-container">
        <iframe 
          width="100%" 
          height="100%" 
          frameBorder="0" 
          className="embed-responsive-item embed-tour-iframe animated fadeIn" 
          src="https://floorfy.com/tour/968874?sound=no&amp;load=true" 
          allow="autoplay" 
          allowFullScreen={true}
          title="Interactive Virtual Tour"
        ></iframe>
      </div>
    </div>
  );
};

export default VR;